import { LineModelStyle } from "@iventis/domain-model/model/lineModelStyle";
import { ModelStyle } from "@iventis/domain-model/model/modelStyle";

export type ModelLayerStyle = ModelStyle | LineModelStyle;
